const companiesRoute = "/companies/:companyId";
const api = {
  companies: {
    connections: {
      single: `${companiesRoute}/connections/:connectionId`,
    },
    data: {
      history: `${companiesRoute}/data/history`,
    },
    push: {
      pushOperations: `${companiesRoute}/push`,
    },
  },
};

export default api;
